export const generateDefaultValues = (listDefinition) => {
    return listDefinition.reduce((acc, field) => {
        acc[field.name] = '';
        return acc;
    }, {});
};
